// Port of api/fuel/app/classes/filter/search/games/filters/query/play/date/sometime.php
export default {
	name: 'play.date.sometime',
	priority: 55,
	require: function(config, filter) {
		return filter.played && filter.played.sometime && (filter.played.sometime.from || filter.played.sometime.to)
	},
	run: function(config, filter, data, query) {
		if (filter.played.sometime.from) query.where('p.play_date', '>=', filter.played.sometime.from)
		if (filter.played.sometime.to) query.where('p.play_date', '<=', filter.played.sometime.to)
	}
}
